module.exports = __webpack_public_path__ + "img/gb897_1988.prt.2e94f96f.jpg";